import { useQuery } from 'react-query';

import type { AvailableSingleCallJob } from 'state/remote/types';

type FreelancerAcceptedJobs = {
  data: AvailableSingleCallJob[];
  isLoading?: boolean;
  error: Error | null;
};

const useGetAcceptedJobsForFreelancer = (): FreelancerAcceptedJobs => {
  const getAcceptedJobs = async () => {
    const response = await fetch('/api/jobs/planned/');
    if (response.ok) return response.json();
    throw new Error('Something went wrong');
  };

  const { isLoading, error, data } = useQuery<
    Array<AvailableSingleCallJob>,
    Error
  >(['get-accepted-single-call-jobs'], getAcceptedJobs);
  let filteredData = [] as AvailableSingleCallJob[];
  if (data && data?.length > 0) {
    const today = new Date().toISOString().split('T')[0];
    filteredData = data.filter((job) => {
      return job.date >= today;
    });
  }

  return { data: filteredData ?? [], error, isLoading };
};

export default useGetAcceptedJobsForFreelancer;
